export enum TextFieldInputType {
  TEXT = 'text',
  DATETIME = 'datetime',
  NUMBER = 'number',
  EMAIL = 'email',
  TEL = 'tel',
  TIME = 'time'
}

export const TEXTFIELD_INPUT_TYPES = Object.values(TextFieldInputType).map(value => value.valueOf());

export enum TextFieldContainerType {
  TEXT = 'textfield',
  NUMBER = 'numbertextfield',
  EMAIL = 'emailtextfield',
  PHONE = 'phonetextfield',
  DATETIME = 'datetimetextfield',
  TEMPERATURE = 'temperaturetextfield',
  TIME = 'timetextfield',
}

export const TEXTFIELD_CONTAINER_TYPES = Object.values(TextFieldContainerType).map(value => value.valueOf());

export const FILTER_STATUS_ALLE = "Alle";

export class StatusCodes {

  PUBLISH: number = 0;
  SAVE: number = 1;
  SCHEDULE: number = 2;
  UNPUBLISHED: number = 3;
}

export enum EventBusTypes {
  KI_REFRESH_EVENT = 'KI_REFRESH_EVENT',
  KI_BUTTON_EVENT = 'KI_BUTTON_EVENT',
  /** Klick auf "MSWR-MOS laden": die Grafik-Boxen holen ihre Werte vom Rest-Service. */
  MSWR_LOAD_EVENT = 'MSWR_LOAD_EVENT',
  /**
   * Eine Karte hat ihre MOS-Datei geladen, aber keine ihrer Boxen trägt einen Schlüssel
   * dafür – die Zeile (z.B. "Heute") kommt in der Datei nicht vor. Nutzlast `MosOhneWerte`;
   * `DocumentDetailComponent` bündelt die Meldungen eines Knopfdrucks zu **einer** Snackbar.
   */
  MOS_OHNE_WERTE_EVENT = 'MOS_OHNE_WERTE_EVENT',
  /** Klick auf "leeren": alle Grafik-Boxen in allen Reitern werden geleert. */
  CLEAR_BOXES_EVENT = 'CLEAR_BOXES_EVENT',
  /**
   * Klick auf "KI-Auswahl aufheben" an einer Zeilenüberschrift: alle gelben Kästchen (`ai`)
   * der Karten dieser Zeile werden abgehakt – Werte, rote Kästchen und der Schalter "Temp"
   * bleiben stehen. Nutzlast `GrafikUmfang` mit den Karten der Zeile.
   */
  KI_AUSWAHL_AUFHEBEN_EVENT = 'KI_AUSWAHL_AUFHEBEN_EVENT',
  /** Klick auf "Speichern" bzw. Strg+S: der Datensatz wird ohne Dialog abgelegt. */
  SAVE_EVENT = 'SAVE_EVENT',
  /** Klick auf "für COSMO übernehmen": die Grafik-Werte des Reiters wandern nach COSMO. */
  COSMO_TAKEOVER_EVENT = 'COSMO_TAKEOVER_EVENT',
  /**
   * Klick auf "eingetragene Daten laden" in der Leiste des Lokalzeit-Reiters "Tendenzen/Prognosen"
   * (neben "MSWR-MOS laden"): die TV-Werte der drei Aussichtentage (Zeile "ganz") wandern in die
   * Spalten Tag 2/3/4 der Prognose-Karte. Nutzlast ist der `GrafikUmfang` der Leiste (darin die
   * Prognose-Karte); der Empfänger braucht das ganze Dokument, weil die Quellen in anderen Reitern liegen.
   */
  PROGNOSE_UEBERNAHME_EVENT = 'PROGNOSE_UEBERNAHME_EVENT',
  /**
   * Ein gespiegeltes Warnschild wurde in seiner Karte geändert (05.11.2026): die Warnschild-Kästchen
   * der Zeile "Tag" der Lokalzeit-Prognose-Karte und das Warnschild `wert` der Karte 3 des jeweiligen
   * Aussichtentags zeigen denselben Wert. Nutzlast `WarnschildSpiegel` (Karte, Box, neuer Wert); der
   * Empfänger (`DocumentDetailComponent`, der das Dokument hat) schreibt den Wert in die Partner-Karte
   * und schickt dafür `GRAFIK_WERTE_GEAENDERT_EVENT`.
   */
  WARNSCHILD_SPIEGEL_EVENT = 'WARNSCHILD_SPIEGEL_EVENT',
  /**
   * Die Werte einiger Karten wurden **im Dokumentbaum** geändert (`image.values`), nicht
   * über ihre Bild-Komponente – z.B. von "für COSMO übernehmen". Nutzlast ist ein
   * `GrafikUmfang` mit den betroffenen Karten; schon gerenderte Karten bauen ihre Anzeige
   * daraufhin aus dem Dokument neu auf.
   */
  GRAFIK_WERTE_GEAENDERT_EVENT = 'GRAFIK_WERTE_GEAENDERT_EVENT',
  /**
   * Der Sync-Schalter einer NRW-Karte "feine Unterteilung" bzw. "sehr feine Unterteilung"
   * wurde umgelegt: die jeweils andere Karte derselben Zeile legt ihren Sync mit um, als
   * wäre auch ihr Schalter gedrückt worden. Nutzlast `SyncPartner`.
   */
  SYNC_PARTNER_EVENT = 'SYNC_PARTNER_EVENT',
  /**
   * Klick auf "KI-Texte erzeugen" über den Grafiken: aus dem Wettersymbol einer Karte
   * wird ein Vorhersagetext erzeugt. Anders als KI_BUTTON_EVENT kommt die Eingabe nicht
   * aus einem Textfeld, sondern aus den Grafik-Werten.
   */
  KI_GRAFIK_EVENT = 'KI_GRAFIK_EVENT',
  /**
   * Klick auf "für Videotext übernehmen" im Reiter "KI-Texte" von Nordrhein-Westfalen:
   * stumpfer Kopiervorgang, der die ausgefüllten KI-Texte unverändert in die
   * gleichnamigen Videotext-Boxen schreibt.
   */
  VIDEOTEXT_TAKEOVER_EVENT = 'VIDEOTEXT_TAKEOVER_EVENT',
  /**
   * Klick auf "für COSMO übernehmen" im Reiter "KI-Texte" von Nordrhein-Westfalen:
   * derselbe stumpfe Kopiervorgang wie {@link VIDEOTEXT_TAKEOVER_EVENT}, aber in COSMOs
   * eigenen Reiter "KI-Texte". Nicht zu verwechseln mit {@link COSMO_TAKEOVER_EVENT},
   * das Grafik-Werte überträgt statt Texte.
   */
  COSMO_TEXT_TAKEOVER_EVENT = 'COSMO_TEXT_TAKEOVER_EVENT',
}

